var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99609 16.3738C7.60395 17.3523 10.4223 17.8401 13.2644 17.8048C16.1066 17.8401 18.9249 17.3523 21.5328 16.3738C19.8791 9.2188 19.8791 4.92578 13.2644 4.92578C6.64976 4.92578 6.64976 9.2188 4.99609 16.3738Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.916667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2646 3.49414V4.92515",
    stroke: "currentColor",
    strokeWidth: 0.916667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95703 17.5938V17.8048C9.95703 18.5639 10.3055 19.2918 10.9257 19.8286C11.546 20.3653 12.3872 20.6668 13.2644 20.6668C14.1415 20.6668 14.9828 20.3653 15.603 19.8286C16.2233 19.2918 16.5717 18.5639 16.5717 17.8048V17.5938",
    stroke: "currentColor",
    strokeWidth: 0.916667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.ee3465f41fcb0608e166e22e5749c79a.svg";
export { ForwardRef as ReactComponent };